var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{attrs:{"options":_vm.options,"size":_vm.size},on:{"input":_vm.input},model:{value:(_vm.companyType),callback:function ($$v) {_vm.companyType=$$v},expression:"companyType"}})}
var staticRenderFns = []

export { render, staticRenderFns }